import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StyleIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Paint brush / style icon */}
      {/* Brush handle */}
      <path
        d="M3 21l4-4"
        stroke={color}
        strokeWidth={strokeWidth * 1.5}
        strokeLinecap="round"
      />
      {/* Brush ferrule */}
      <path
        d="M7 17l3-3"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Brush bristles / tip */}
      <path
        d="M10 14c2-2 4-4 8-6 1 3-1 6-4 8-2 1-4 1-5 0s-1-3 1-2z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill={color}
        fillOpacity="0.3"
      />
    </BaseIcon>
  ),
);

StyleIcon.displayName = 'StyleIcon';
